<template>
    <main class="user-data-page max-width-container">
        <h1 class="form-title">Your data</h1>
        <ImportForm
            validated
            :errors="errors"
            :success-message="successMessage"
            @submit-form="submitForm"
        />

        <section class="data-section">
            <h2 class="data-section-label">Export</h2>
            <div class="export-links">
                <a href="/export/trips">
                    <Bttn class="outlined">Trips</Bttn>
                </a>
                <a href="/export/bucket-lists">
                    <Bttn class="outlined">Bucket lists</Bttn>
                </a>
            </div>
        </section>

        <LoadingScreen v-if="!loaded" message="Loading your imports…" />
        <section v-else-if="hasJobs" class="data-section">
            <h2 class="data-section-label">Imports · {{ jobs.length }}</h2>
            <InfoRow
                v-for="job in jobs"
                :key="job.id"
                :name="`${$enumGet('import_job_type', job.type)} · ${$formatDate(job.created_at, true)}`"
                icon="upload_file"
            >
                <span
                    v-if="
                        job.status === 'processing' || job.status === 'pending'
                    "
                    class="info-row-stat"
                >
                    {{ Math.round(job.progress * 100) }}%
                </span>
                <a
                    v-else-if="job.status === 'fail'"
                    :href="`/export/errors/${job.id}`"
                >
                    Download errors
                </a>
                <span v-else-if="job.status === 'error'" class="info-row-stat">
                    {{ job.message }}
                </span>
                <div class="status-badge" :class="job.status">
                    {{ $enumGet("import_job_status", job.status) }}
                </div>
            </InfoRow>
        </section>

        <section class="actions">
            <router-link to="/">
                <Bttn class="outlined">Back</Bttn>
            </router-link>
        </section>
    </main>
</template>
<script>
import { fetch, create, handleResponse } from "js/lib/server";
import BaseFormWrapper from "js/components/base/BaseFormWrapper";
import ImportForm from "js/components/forms/ImportForm";
import InfoRow from "js/components/list-items/InfoRow";
import LoadingScreen from "js/components/common/LoadingScreen";

export default {
    name: "UserData",
    components: {
        ImportForm,
        InfoRow,
        LoadingScreen,
    },
    extends: BaseFormWrapper,
    data() {
        return {
            jobs: [],
            loaded: false,
            successMessage: "",
        };
    },
    computed: {
        hasJobs() {
            return !!this.jobs.length;
        },
    },
    mounted() {
        this.refreshJobs();
    },
    methods: {
        async refreshJobs() {
            let refresh = false;
            this.jobs = await fetch("/api/imports").then(handleResponse);
            this.loaded = true;
            this.jobs.forEach((job) => {
                if (job.status === "processing" || job.status === "pending") {
                    refresh = true;
                }
            });
            if (refresh) {
                setTimeout(() => {
                    this.refreshJobs();
                }, 1000 * 10);
            }
        },
        async submitForm(data) {
            const formData = new FormData();
            formData.append("type", data.type);
            formData.append("file", data.file);
            let headers = {
                "Content-Type": "multipart/form-data",
            };
            create("/api/imports", formData, { headers })
                .then(() => {
                    this.errors = {};
                    this.successMessage = "Import started";
                    this.refreshJobs();
                })
                .catch((err) => {
                    this.successMessage = "";
                    this.handleResponseErrors(err);
                });
        },
    },
};
</script>
